// Hook de cache para Lives usando Tanstack Query
// Mantiene la misma interfaz que los servicios originales
import { useQuery } from '@tanstack/react-query'
import LiveService from '../services/live'

/**
 * Hook de cache para lives - NO CAMBIA LA LÓGICA EXISTENTE
 * Solo añade una capa de cache inteligente
 */
export const useLiveQueries = userId => {
	// Cache para mis lives reservados
	const myLivesQuery = useQuery({
		queryKey: ['my-lives', userId],
		queryFn: () => LiveService.getLives({ userId }),
		staleTime: 2 * 60 * 1000, // 2 minutos - lives pueden cambiar
		cacheTime: 10 * 60 * 1000, // 10 minutos en cache
		enabled: !!userId,
		retry: 2,
		retryDelay: 1000
	})

	// Cache para todos los lives disponibles
	const allLivesQuery = useQuery({
		queryKey: ['all-lives', userId],
		queryFn: () => LiveService.getAllLives({ userId }),
		staleTime: 90 * 1000, // 1.5 minutos - lives de hoy pueden cambiar frecuentemente
		cacheTime: 5 * 60 * 1000, // 5 minutos en cache
		enabled: !!userId,
		retry: 2,
		retryDelay: 1000
	})

	// Función wrapper que mantiene la interfaz original
	const getCachedLives = () => {
		return new Promise((resolve, reject) => {
			if (myLivesQuery.data) {
				// Si tenemos datos en cache, los devolvemos inmediatamente
				resolve(myLivesQuery.data)
			} else if (myLivesQuery.error) {
				reject(myLivesQuery.error)
			} else {
				// Si no hay datos, refetch y esperar
				myLivesQuery.refetch().then(result => {
					if (result.data) {
						resolve(result.data)
					} else {
						reject(result.error || new Error('No data available'))
					}
				})
			}
		})
	}

	// Función wrapper para all lives
	const getCachedAllLives = () => {
		return new Promise((resolve, reject) => {
			if (allLivesQuery.data) {
				resolve(allLivesQuery.data)
			} else if (allLivesQuery.error) {
				reject(allLivesQuery.error)
			} else {
				allLivesQuery.refetch().then(result => {
					if (result.data) {
						resolve(result.data)
					} else {
						reject(result.error || new Error('No data available'))
					}
				})
			}
		})
	}

	return {
		// Datos de las queries
		lives: myLivesQuery.data,
		allLives: allLivesQuery.data,

		// Estados de loading
		livesLoading: myLivesQuery.isLoading,
		allLivesLoading: allLivesQuery.isLoading,

		// Errores
		livesError: myLivesQuery.error,
		allLivesError: allLivesQuery.error,

		// Funciones wrapper que mantienen la interfaz original
		getCachedLives,
		getCachedAllLives,

		// Funciones para invalidar cache cuando sea necesario
		invalidateLives: () => myLivesQuery.refetch(),
		invalidateAllLives: () => allLivesQuery.refetch()
	}
}

export default useLiveQueries
